// extracted by mini-css-extract-plugin
export default {"card":"Products_card__V6oxK"};